import { emitEvent } from "../../Shared/Assets/src/tagmanager";

document.querySelectorAll<HTMLElement>("[data-campaign-form]")?.forEach(campaignForm => {
  const form = campaignForm.querySelector<HTMLFormElement>("form");

  if (form) {
    form.addEventListener("submit", () =>
      emitEvent(
        "CampaignForm submitted",
        { campaignCode: campaignForm.dataset.campaignCode },
        false
      )
    );
  }
});
